import { render, staticRenderFns } from "./Communities.vue?vue&type=template&id=796c220a&"
import script from "./Communities.vue?vue&type=script&lang=js&"
export * from "./Communities.vue?vue&type=script&lang=js&"
import style0 from "./Communities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports